module.exports = __webpack_public_path__ + "static/media/thumbnail_paragard-information@3x.b9a32e02.jpg";